module.exports = __webpack_public_path__ + "static/media/ug.3a52a944.svg";